import {useLocation, useNavigate, useSearchParams} from "react-router-dom"
import {useDispatch, useSelector} from "react-redux"
import {updateModalProduct} from "redux/actions/product"
import { useEffect } from 'react'

export default function useShowProductDescriptionModal(product) {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  const {modalProduct} = useSelector(({product}) => product)
  const [searchParams] = useSearchParams()
  const item = searchParams.get("item")

  useEffect(() => {
    if (item && !modalProduct && item === product?.slug) {
      dispatch(updateModalProduct(product))
    }
  }, [item, dispatch, product, modalProduct])

  function handleShowProductDescriptionModal() {
    if (!product?.slug) {
      console.log("❌ Cannot show product description modal: product or slug is missing", product)
      return
    }
    const params = new URLSearchParams(location.search)
    params.set("item", product.slug)
    const search = params.toString()
    navigate({
      pathname: location.pathname,
      search: search ? `?${search}` : "",
    })
    dispatch(updateModalProduct(product))
  }
  
  return handleShowProductDescriptionModal
}
